"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFoundPage = void 0;
var react_1 = __importDefault(require("react"));
var content_1 = require("../elements/content");
var layout_1 = require("../elements/layout");
var use_lang_1 = require("../../hooks/use-lang");
var app_screen_layout_1 = require("../app/app-screen-layout");
var browser = typeof window !== "undefined" && window;
var NotFoundPage = function (props) {
  var t = (0, use_lang_1.useLang)();
  return browser && react_1.default.createElement(app_screen_layout_1.AppScreenLayout, null, react_1.default.createElement(layout_1.Layout, {
    pad: true
  }, react_1.default.createElement(content_1.Content, null, react_1.default.createElement("h2", null, t("Page not found")), react_1.default.createElement("p", null, t("Sorry, this page doesn't exist in this website. You may have followed an invalid or outdated link.")), react_1.default.createElement("p", null, react_1.default.createElement("a", {
    href: "/"
  }, t('Return to the home page'))))));
};
exports.NotFoundPage = NotFoundPage;
exports.default = exports.NotFoundPage;